const isDevelopmentEnvironment = () => {
  return (
    window.location.origin.includes('staging') ||
    window.location.origin.includes('dev') ||
    window.location.origin.includes('localhost')
  );
};

export default isDevelopmentEnvironment;
